<template>
    <Dropdown class="select w-100">
        <template #default>
            <div class="form-control selected-credential-type cursor-pointer bg-primary">
                <fa-icon icon="th-large" class="mr-3" />

                <span v-if="credentialType">{{ credentialType.name }}</span>
                <span v-else>{{$t('credentials.select_account_type')}}</span>
                <div class="pull-right">
                    <fa-icon icon="chevron-down" />
                </div>
            </div>
        </template>
        <template #content="{closeMenu}">
            <div class="sidebar-light">
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-for="item in credentialTypes" :key="item.type">
                        <a class="nav-link cursor-pointer"
                           :class="{active: item.type === credentialTypeName}"
                           @click="setCredentialTypeName(item.type); closeMenu()"
                        >
                            <div class="initials bg-primary-400 mr-2">
                                {{getInitials(item.name || 'Bez nazwy')}}
                            </div>

                            {{ item.name || 'Bez nazwy' }}
                        </a>
                    </li>
                </ul>
            </div>
        </template>
    </Dropdown>
</template>

<script>

    import store from "../store/store";

    export default {
        name: "CredentialTypeSelect",
        computed: {
            ...store.mapFields(['credentialTypeName']),
            ...store.mapState(['credentialTypes']),
            ...store.mapGetters(['credentialType'])
        },

        data: () => ({
            radius: 50,
        }),

        methods: {
            getInitials(name) {
                return name.split(' ').map((n)=>n[0]).join('');
            },

            setCredentialTypeName(type) {
                this.credentialTypeName = type;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .initials {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
    }

    .selected-credential-type {
        line-height: 35px;
        height: 50px;
    }

    .nav-link {
        line-height: 30px;
    }

</style>
